import React, { useEffect, useState } from 'react'
import { useOffersList } from './hooks'
import { CButton, CCardBody } from '@coreui/react-pro'
import { path } from '../../../../../libs'
import { Table, Tag } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import CIcon from '@coreui/icons-react'
import { cilZoom } from '@coreui/icons'
import { Offer, OfferLink } from './types'

export const OffersList: React.FC = () => {
  const { offers, totalCountOfOffers, loading, onChangeOffersList } =
    useOffersList()

  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)

  const handleTableChange = ({
    currentPage,
    currentPageSize,
  }: {
    currentPage?: number
    currentPageSize?: number
  }) => {
    if (currentPage) {
      setPage(currentPage)
    }
    if (currentPageSize) {
      setPageSize(currentPageSize)
    }
  }

  useEffect(() => {
    onChangeOffersList({
      limit: pageSize,
      page: page,
    })
  }, [pageSize, page])

  const columns: ColumnsType<Offer> = [
    {
      title: 'ID',
      dataIndex: 'id',
      sorter: (a, b) => a.id - b.id,
      defaultSortOrder: 'descend',
    },
    {
      title: 'Name',
      dataIndex: 'title',
      key: 'title',
      sorter: true,
    },
    {
      title: 'Langs',
      dataIndex: 'offerLink',
      render: (offerLink: OfferLink[]) => {
        return <div>{offerLink.map((item) => item.lang).join(', ')}</div>
      },
    },
    {
      title: 'Status',
      dataIndex: 'isVisible',
      render: (status: string) => {
        return (
          <Tag color={status ? 'success' : 'error'}>
            {status ? 'Active' : 'Inactive'}
          </Tag>
        )
      },
    },
    {
      title: 'Links',
      dataIndex: 'offerLink',
      render: (offerLink: OfferLink[]) => {
        return (
          <div>
            {offerLink.map((item) => (
              <div>
                <a href={item.link} target="_blank">
                  {item.link}
                </a>
              </div>
            ))}
          </div>
        )
      },
    },
    {
      title: 'Actions',
      fixed: 'right',
      width: 100,
      render: (item) => {
        return (
          <>
            <CButton
              color="secondary"
              className="me-2"
              title="View"
              href={path.ib.ad.offers.edit(item.id)}
            >
              <CIcon icon={cilZoom} />
            </CButton>
          </>
        )
      },
    },
  ]

  return (
    <CCardBody>
      <CButton
        color="primary"
        className="mb-2"
        href={path.ib.ad.offers.create()}
      >
        Create offer
      </CButton>
      <Table
        dataSource={offers}
        bordered={true}
        scroll={{ x: true }}
        loading={loading}
        rowKey="offersTable"
        columns={columns}
        pagination={{
          showSizeChanger: true,
          total: totalCountOfOffers,
        }}
        onChange={(pagination, sorter) =>
          handleTableChange({
            //@ts-ignore
            currentPage: pagination.current, //@ts-ignore
            currentPageSize: pagination.pageSize, //@ts-ignore
            currentOrderDirection: sorter.order, //@ts-ignore
            currentOrderBy: sorter.field,
          })
        }
      ></Table>
    </CCardBody>
  )
}
